export default {
  common: [
    {
      label: '5개씩 보기',
      value: 5
    },
    {
      label: '10개씩 보기',
      value: 10
    },
    {
      label: '20개씩 보기',
      value: 20
    },
    {
      label: '30개씩 보기',
      value: 30
    },
    {
      label: '40개씩 보기',
      value: 40
    },
    {
      label: '50개씩 보기',
      value: 50
    },
    {
      label: '100개씩 보기',
      value: 100
    }
  ]
}
